import { IRouteConfig, IRouteConfigWithComponent, PermissionKeys } from '../shared';
import { ReportsPage } from './pages/reports.page';
import { ReportPage } from './pages/report.page';

export const reportsRoutes: IRouteConfig[] = [
    {
        path: '/reports/*',
        component: ReportsPage,
        requiredPermissions: [PermissionKeys.REPORTS_READ],
    },
];

export const reportSubRoutes: IRouteConfigWithComponent[] = [
    {
        path: '/:id',
        component: ReportPage,
        requiredPermissions: [PermissionKeys.REPORTS_READ],
    },
];
